import { render, staticRenderFns } from "./createTeamMapping.vue?vue&type=template&id=3321648e"
import script from "./createTeamMapping.vue?vue&type=script&lang=js"
export * from "./createTeamMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports